import React from "react"
import Helmet from "react-helmet"

const SITE_URL = "https://www.estrelaguia.com.br"

// Canonical self-referencial para TODAS las páginas, a partir de la ruta real.
// Las páginas que ya emiten su propio canonical (SEO con pathname) lo pisan:
// react-helmet conserva un solo <link rel="canonical"> y gana el más interno.
export const canonicalFor = pathname => {
  if (!pathname) return null
  if (pathname.startsWith("/404") || pathname.startsWith("/offline-plugin")) return null
  const clean = pathname.split("?")[0].split("#")[0]
  const withSlash = clean.endsWith("/") || /\.[a-z0-9]+$/i.test(clean) ? clean : `${clean}/`
  return `${SITE_URL}${withSlash}`
}

// wrapPageElement compartido por gatsby-ssr.js y gatsby-browser.js.
export const wrapPageElement = ({ element, props }) => {
  const href = canonicalFor(props.location && props.location.pathname)
  return (
    <>
      {href && (
        <Helmet>
          <link rel="canonical" href={href} />
        </Helmet>
      )}
      {element}
    </>
  )
}
